import React from 'react';
import PropTypes from 'prop-types';
import { QuickVaultCreditCardPaymentButton } from '@PetSureAustralia/petsure-payment/react-wrapper';
import { PAYMENT_METHOD_OPTION } from '../../../constants/constants';
import { SESSION_STORAGE_KEYS } from '../../../constants/sessionStorageKeys';
import { CSPUrlsMap } from '../../../routes/CSPUrlsMap';
import { COMMUNITY_CODE, ENCRYPTED_USER_STATE, MAP_RESPONSE_TYPE } from '../../../constants/payment';
import { FullPetDetailsPropTypes } from '../../../propTypes/petDetails';
import { legacyPolicyNumberHandler } from '../../../helpers/paymentHelper';

export const PremiumPaymentFooter = ({ paymentMethod, handleClose, handleUpdateDirectDebit, cardPaymentProps }) => {
  const isCardPayment = paymentMethod === PAYMENT_METHOD_OPTION.CARD;

  return (
    <div className="footerModalContainer">
      <button
        type="button"
        className="button primary outline"
        onClick={handleClose}
      >
        <span className="labelText">Cancel</span>
      </button>

      {isCardPayment ? (
        <QuickVaultCreditCardPaymentButton
          quickWebTokenHandlerEndpoint={`${process.env.CSP_MIDDLEWARE_API}/api/payment/generatePremiumPaymentWestpacToken`}
          formUrl={cardPaymentProps.formUrl}
          communityCode={COMMUNITY_CODE}
          encryptedUserState={ENCRYPTED_USER_STATE}
          customerReferenceNumber={legacyPolicyNumberHandler(cardPaymentProps.activePet?.PolicyNumber)}
          returnUrl={`${window.location.origin}${CSPUrlsMap.bankDetails.url}?userState=${cardPaymentProps.returnUrlState.userState}&policyNumberState=${cardPaymentProps.returnUrlState.policyState}`}
          cancelUrl={`${window.location.origin}${CSPUrlsMap.bankDetails.url}?payment=cancelled`}
          supplierBusinessCode={cardPaymentProps.supplierBusinessCode}
          partner={cardPaymentProps.partnerPrefix}
          mapResponseType={MAP_RESPONSE_TYPE}
          requestHeaders={{
            'Content-Type': 'application/json',
            Authorization: sessionStorage?.getItem(SESSION_STORAGE_KEYS.CSP_ACCESS_TOKEN)
          }}
          buttonClasses="button primary"
          buttonText="Next"
        />
      ) : (
        <button
          type="button"
          className="button primary"
          onClick={handleUpdateDirectDebit}
        >
          <span className="labelText">Update</span>
        </button>
      )}
    </div>
  );
};

PremiumPaymentFooter.propTypes = {
  paymentMethod: PropTypes.number,
  handleClose: PropTypes.func,
  handleUpdateDirectDebit: PropTypes.func,
  cardPaymentProps: PropTypes.shape({
    formUrl: PropTypes.string,
    supplierBusinessCode: PropTypes.string,
    partnerPrefix: PropTypes.string,
    activePet: FullPetDetailsPropTypes,
    returnUrlState: PropTypes.shape({
      userState: PropTypes.string,
      policyState: PropTypes.string
    })
  })
};
